export default __webpack_public_path__ + "static/image-highlight-vps-status-66d55535e9440819b0bfc340cd7b1127.png";